import React, { type FC, type PropsWithChildren } from 'react'

import { useRecoilValue } from 'recoil'

import { Loading } from 'mailup-web-components'

import ErrorFeedback from 'Components/ErrorFeedback'
import PageContainer from 'Components/PageContainer'

import { pageState } from 'State/page'

type PageProps = PropsWithChildren<{
  className?: string
  onReload: () => void | Promise<void>
}>

const Page: FC<PageProps> = ({ children, className, onReload }) => {
  const { status, loading, errorMessage } = useRecoilValue(pageState)

  return (
    <>
      <Loading open={loading} />

      <PageContainer className={className}>
        {status === 'error' ? (
          <ErrorFeedback
            error={errorMessage}
            onReload={onReload}
            className=""
          />
        ) : status === 'ready' ? (
          children
        ) : null}
      </PageContainer>
    </>
  )
}

export default Page
